module.exports = __webpack_public_path__ + "img/6_ralph_h.26fb9b37.png";